import gql from 'graphql-tag';

export const CREATE_VEHICLE_MUTATION = gql`
  mutation createVehicle($vehicleInputDetails: VehicleInput!) {
    createVehicle(vehicleInput: $vehicleInputDetails) {
      id
      testatorId
      make
      model
      color
      displayName
      outstandingDebt
      specificDonation {
        id
      }
    }
  }
`;

export const UPDATE_VEHICLE_MUTATION = gql`
  mutation updateVehicle($id: ID!, $vehicleInputDetails: VehicleInput!) {
    updateVehicle(id: $id, vehicleInput: $vehicleInputDetails) {
      id
      testatorId
      make
      model
      color
      outstandingDebt
      displayName
      specificDonation {
        id
      }
    }
  }
`;

export const DELETE_VEHICLE_MUTATION = gql`
  mutation deleteVehicle($id: ID!) {
    deleteVehicle(id: $id) {
      id
    }
  }
`;
